import React from "react";
import AniLink from "gatsby-plugin-transition-link/AniLink";

const Button = ({
  className,
  href,
  outboundLink,
  modal,
  onClick,
  type,
  altStyle,
  text,
}) => {
  const Tag = href ? AniLink : "button";
  const target = outboundLink && "_blank";
  const rel = outboundLink && "noopener noreferrer";
  let link = true;

  href && (link = !href.includes("tel:") && !href.includes("mailto:"));

  return (
    <Tag
      className={`group font-bold inline-flex items-center justify-center space-x-2.5 ${
        altStyle
          ? `text-secondary-50`
          : `text-primary-600 hover:text-primary-600`
      } ${className}`}
      {...(link ? { fade: "true", to: href } : { href: href })}
      target={target}
      rel={rel}
      data-modal-open={modal}
      onClick={onClick}
      type={type}
      alt-style={altStyle}
    >
      <div>{text}</div>
      <i className="far fa-arrow-right text-xl relative left-0 group-hover:left-1.5 transition-all duration-300 ease-linear"></i>
    </Tag>
  );
};

export default Button;
